<template>
  <div id="jys">
    <pc-header v-if="!showMobileComponent && !$route.meta.isLogin" />
    <m-header v-if="showMobileComponent && !$route.meta.hideHeader"></m-header>

    <router-view v-if="$route.meta.isLogin"/>
    <div v-else class="flex-1 mobile-center">
      <div class="main-center">
        <!-- <transition name="fade" mode="out-in" appear> -->
        <router-view />
        <!-- </transition> -->
      </div>
    </div>
    <pc-footer v-if="!showMobileComponent" />
    <tabbar v-if="showMobileComponent && !$route.meta.hideFooter" />
  </div>
</template>

<script>
import PcHeader from '@/components/pc/Header.vue';
import PcFooter from '@/components/pc/Footer.vue';

import MHeader from '@/components/mobile/Header.vue';
import Tabbar from '@/components/mobile/Tabbar.vue';

export default {
  components: {
    PcHeader,
    PcFooter,

    MHeader,
    Tabbar,
  },
  created() {
    // 初始化 state.showMobileComponent
    this.$store.commit('changeMobileComponent', this.showMobileComponent);
  }
}
</script>

<style lang="less">
.fade-enter-active, .fade-leave-active { transition: opacity .5s; }
.fade-enter, .fade-leave-to { opacity: 0; }
@import url('./assets/less/common.less');
@import url('./assets/font/iconfont.css');
</style>
